import { Node } from "@tiptap/core";

const StyleNode = Node.create({
  name: "style",
  group: "block",
  content: "text*",
  parseHTML: () => [
    {
      tag: "style",
    },
  ],
  renderHTML: ({ HTMLAttributes }) => ["style", HTMLAttributes, 0],
});

export default StyleNode;
